export default "__VITE_ASSET__BStux2yu__"